import { render, staticRenderFns } from "./AnswerPage.vue?vue&type=template&id=2b450792&scoped=true&"
import script from "./AnswerPage.vue?vue&type=script&lang=js&"
export * from "./AnswerPage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AnswerPage.vue?vue&type=style&index=1&id=2b450792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b450792",
  null
  
)

export default component.exports